import React from 'react';
import { cn } from '@/lib/utils';

export function KPICard({ label, value, icon: Icon, accent = 'red', delta, sublabel, testid }) {
  const accents = {
    red: 'before:bg-[#DC2626]',
    gold: 'before:bg-[#FBBF24]',
    blue: 'before:bg-[#0EA5E9]',
    green: 'before:bg-[#10B981]',
    slate: 'before:bg-slate-300',
  };
  const iconBg = {
    red: 'bg-red-50 text-red-600',
    gold: 'bg-amber-50 text-amber-600',
    blue: 'bg-sky-50 text-sky-600',
    green: 'bg-emerald-50 text-emerald-600',
    slate: 'bg-slate-50 text-slate-600',
  };
  return (
    <div
      data-testid={testid || 'kpi-card'}
      className={cn(
        'relative bg-white rounded-2xl border border-slate-200 shadow-premium p-5 transition-all duration-200 hover:shadow-elevated hover:-translate-y-0.5',
        'before:content-[""] before:absolute before:left-0 before:top-4 before:bottom-4 before:w-1 before:rounded-r',
        accents[accent]
      )}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</p>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-3xl md:text-4xl font-extrabold text-slate-900 tabular leading-none" style={{ fontFamily: 'Plus Jakarta Sans' }}>
              {value}
            </span>
            {delta && <span className="text-xs font-medium text-slate-500">{delta}</span>}
          </div>
          {sublabel && <p className="mt-2 text-xs text-slate-500">{sublabel}</p>}
        </div>
        {Icon && (
          <div className={cn('w-11 h-11 rounded-xl flex items-center justify-center', iconBg[accent])}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}
